// Constants
import { SensitivityIconType } from "../constants/SensitivityConstants";
// Controls
import { Shield, ShieldError, ShieldFilled, ShieldLock, ShieldLockFilled, ShieldQuestion } from "@ms/planner-generic-controls/lib/local/icons";
//Styles
import { useSensitivityIconStyles } from "./SensitivityIcon.styles";
// Utilities
import * as React from "react";
export const SensitivityIcon = (props)=>{
    const { iconType, color } = props;
    const classes = useSensitivityIconStyles();
    switch(iconType){
        case SensitivityIconType.Tag:
            return /*#__PURE__*/ React.createElement("span", {
                className: classes.sensitivityIconContainer,
                "data-testid": "sensitivity-icon-tag"
            }, /*#__PURE__*/ React.createElement(ShieldFilled, {
                color: color,
                "aria-hidden": "true"
            }), /*#__PURE__*/ React.createElement(Shield, {
                className: classes.sensitivityIcon,
                "aria-hidden": "true"
            }));
        case SensitivityIconType.TagProtected:
            return /*#__PURE__*/ React.createElement("span", {
                className: classes.sensitivityIconContainer,
                "data-testid": "sensitivity-icon-tag-protected"
            }, /*#__PURE__*/ React.createElement(ShieldLockFilled, {
                color: color,
                "aria-hidden": "true"
            }), /*#__PURE__*/ React.createElement(ShieldLock, {
                className: classes.sensitivityIcon,
                "aria-hidden": "true"
            }));
        case SensitivityIconType.TagRequired:
            return /*#__PURE__*/ React.createElement(ShieldError, {
                "aria-hidden": "true",
                "data-testid": "sensitivity-icon-tag-required"
            });
        case SensitivityIconType.TagUnknown:
        default:
            return /*#__PURE__*/ React.createElement(ShieldQuestion, {
                "aria-hidden": "true",
                "data-testid": "sensitivity-icon-tag-unknown"
            });
    }
};
